import { IApplicationInformation } from 'interfaces/i-application-information'
import { ICalculatorCampaign } from 'interfaces/i-calculator-type'

export function CalculateLoan(
	loanAmount: number,
	repaymentPeriod: number,
	loanInformation: IApplicationInformation,
	roundInstalmentUp: boolean,
): {
	openingFee: number
	monthlyFee: number
	interestRate: number
	instalment: number
} {
	let campaign = getValidCampaign(
		loanInformation.offer.campaigns,
		loanAmount,
		repaymentPeriod,
	)

	let openingFee,
		monthlyFee,
		interestRate = 0
	if (campaign) {
		openingFee = Math.max(
			campaign.openingFee.minimumAmount ?? 0,
			loanAmount * (campaign.openingFee?.rate ?? 0),
		)
		monthlyFee = Math.max(
			campaign.monthlyFee.minimumAmount ?? 0,
			loanAmount * (campaign.monthlyFee?.rate ?? 0),
		)
		interestRate = campaign.interestRate ?? 0
	} else {
		openingFee = Math.max(
			loanInformation.offer.openingFee.minimumAmount ?? 0,
			loanAmount * (loanInformation.offer.openingFee?.rate ?? 0),
		)
		monthlyFee = Math.max(
			loanInformation.offer.monthlyFee.minimumAmount ?? 0,
			loanAmount * (loanInformation.offer.monthlyFee?.rate ?? 0),
		)
		interestRate = loanInformation.offer.interestRate ?? 0
	}

	//Monthly instalment
	let instalment = calculateInstalment(
		loanAmount,
		repaymentPeriod,
		openingFee,
		monthlyFee,
		interestRate,
	)

	return {
		openingFee: openingFee,
		monthlyFee: monthlyFee,
		interestRate: interestRate,
		instalment: roundInstalmentUp
			? roundToDecimalUpwards(instalment, 0)
			: instalment,
	}
}

function getValidCampaign(
	campaigns: ICalculatorCampaign[],
	loanAmount: number,
	repaymentPeriod: number,
): ICalculatorCampaign | undefined {
	let validCampaign = undefined
	campaigns.forEach((campaign) => {
		if (
			campaign.minAmount <= loanAmount &&
			loanAmount <= campaign.maxAmount &&
			campaign.minRepaymentPeriod <= repaymentPeriod &&
			repaymentPeriod <= campaign.maxRepaymentPeriod
		)
			validCampaign = campaign
	})
	return validCampaign
}

function calculateInstalment(
	loanAmount: number,
	repaymentPeriod: number,
	openingFee: number,
	monthlyFee: number,
	interestRate: number, // anual
): number {
	const monthlyInterestRate = interestRate / 12 

	const financedAmount = loanAmount + openingFee * (1 - monthlyInterestRate)

	const annuityFactor =
		monthlyInterestRate /
		(1 - (1 + monthlyInterestRate) ** -repaymentPeriod)

	const monthlyLoanRepayment = financedAmount * annuityFactor

	const monthlyInstalment = monthlyLoanRepayment + monthlyFee

	return monthlyInstalment
}

function roundToDecimalUpwards(number: number, decimals: number): number {
	const multiplier = Math.pow(10, decimals)
	return Math.ceil(number * multiplier) / multiplier
}
